
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlU as ObiOwnShipControlUElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-u.js';
 
 
 

 
 export const ObiOwnShipControlU = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-u',
   elementClass: ObiOwnShipControlUElement,
   events: {
     
   }
  });
 
 